import { __decorate } from "tslib";
// Core
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { maxLength } from 'vuelidate/lib/validators';
// Extends
import { validationMixin } from 'vuelidate';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
// Children
import BaseText from '@/components/BaseText.vue';
import BaseTextArea from '@/components/v2/BaseTextArea';
import FacebookPostPicker from '@/components/v3/modals/FacebookPostPicker.vue';
import FacebookPostThumb from '@/components/v3/FacebookPostThumb.vue';
import ListTransition from '@/components/page_transition/List.vue';
import Modal from '@/components/v3/Modal.vue';
import SwitchTransition from '@/components/page_transition/Switch.vue';
// Models / Helpers
import { maxLength as maxLengthMessage } from '@/helpers/mixins/LocalizationHelper';
// Queries / Mutations
import FacebookPostsQuery from '@/plugins/graphql/queries/v3/fetch-page-posts.gql';
let ExplainerAdditionalDetails = class ExplainerAdditionalDetails extends Mixins(FormValidationsMixin, validationMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.targetAudienceOptions = [
            {
                value: 'ageRange',
                text: 'Age Range',
            },
            {
                value: 'gender',
                text: 'Gender',
            },
            {
                value: 'familyStatus',
                text: 'Family Status',
            },
            {
                value: 'educationLevel',
                text: 'Education Level',
            },
            {
                value: 'incomeLevel',
                text: 'Income Level',
            },
            {
                value: 'region',
                text: 'Specific Region (Philippine Regions)',
            },
            {
                value: 'interestHobbies',
                text: 'Interest and Hobbies',
            },
            {
                value: 'personality',
                text: 'Personality Traits',
            },
            {
                value: 'occupation',
                text: 'Occupation',
            },
        ];
        this.form = {
            keyFeatures: null,
            targetAudience: this.targetAudienceOptions
                .map((el) => {
                return { [el.value]: null };
            })
                .reduce((a, v) => ({
                ...a,
                ...v,
            }), {}),
            tone: [],
            keywords: null,
        };
        this.selectedTargetAudiences = [];
        this.expanded = [false, true];
        this.isFetchPostError = false;
    }
    get hasErrorAndInPreview() {
        return this.$v.$invalid && !this.expanded[0];
    }
    get targetAudienceSummary() {
        const filteredTargetAudiences = this.selectedTargetAudiences.filter((key) => this.form.targetAudience[key] != null);
        if (filteredTargetAudiences.length === 0) {
            return 'None';
        }
        return filteredTargetAudiences
            .map((key) => {
            return this.targetAudienceLabel(key);
        })
            .join(', ');
    }
    targetAudienceLabel(field) {
        return this.targetAudienceOptions.find((el) => el.value === field).text;
    }
    targetAudienceError(field, value, length) {
        if (value?.length > length) {
            return [maxLengthMessage(field, length)];
        }
    }
    get toneAndStyleSummary() {
        if (this.form.tone.length === 0) {
            return 'None';
        }
        if (this.form.tone.length === 1) {
            return `${this.form.tone.length} post selected`;
        }
        return `${this.form.tone.length} posts selected`;
    }
    deselectPost(post) {
        const index = this.form.tone.findIndex((p) => p.id === post.id);
        if (index !== -1) {
            this.form.tone.splice(index, 1);
        }
    }
    created() {
        if (this.formData) {
            this.form = this.formData;
            this.selectedTargetAudiences = Object.keys(this.formData.targetAudience).filter((key) => this.formData.targetAudience[key] != null);
            this.$emit('onLoaded');
        }
    }
};
__decorate([
    Prop({ type: Object, default: null })
], ExplainerAdditionalDetails.prototype, "formData", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], ExplainerAdditionalDetails.prototype, "keyFeatures", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], ExplainerAdditionalDetails.prototype, "targetAudience", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], ExplainerAdditionalDetails.prototype, "tone", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], ExplainerAdditionalDetails.prototype, "keywords", void 0);
ExplainerAdditionalDetails = __decorate([
    Component({
        components: {
            BaseText,
            BaseTextArea,
            FacebookPostPicker,
            FacebookPostThumb,
            ListTransition,
            Modal,
            SwitchTransition,
        },
        apollo: {
            topFacebookPosts: {
                query: FacebookPostsQuery,
                variables() {
                    return {
                        appUuid: this.$store.state.appUUID,
                    };
                },
                update({ fetchPagePosts }) {
                    try {
                        this.form.tone = fetchPagePosts.data;
                    }
                    catch {
                        // fetchPagePosts will be null if no active page is found
                        // catch here instead of check nullness to handle any errors with API call as well
                        this.isFetchPostError = true;
                    }
                    this.$emit('onLoaded');
                },
                skip() {
                    return !this.$store.state.appUUID || this.formData;
                },
            },
        },
        validations: {
            form: {
                keyFeatures: {
                    required: () => {
                        return true;
                    },
                    maxLength: maxLength(50),
                },
                targetAudience: {
                    required() {
                        return this.selectedTargetAudiences.every((key) => {
                            return (this.form.targetAudience[key] === null || this.form.targetAudience[key]?.length < 50);
                        });
                    },
                },
                tone: {
                    maxLength: maxLength(3),
                },
                keywords: {
                    required: () => {
                        return true;
                    },
                    maxLength: maxLength(50),
                },
            },
        },
    })
], ExplainerAdditionalDetails);
export default ExplainerAdditionalDetails;
